{
	"title": "Last carbon reductions",
	"tableHeaders": {
		"cycleId": "Cycle ID",
		"cycleDate": "Shipment date",
		"plant": "Plant",
		"pumped": "LCO₂ pumped net to storage",
		"buffer": "Assured (Buffer)",
		"status": "Status",
		"actions": "Actions"
	},
	"detailsTitle": "Details",
	"assureTitle": "Assure",
	"reductionsHistoryButtonTitle": "Show reductions history"
}
